import { render, staticRenderFns } from "./formGroup.vue?vue&type=template&id=f74390f4&scoped=true"
import script from "./formGroup.vue?vue&type=script&lang=js"
export * from "./formGroup.vue?vue&type=script&lang=js"
import style0 from "./formGroup.vue?vue&type=style&index=0&id=f74390f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74390f4",
  null
  
)

export default component.exports